App.YandexBusinessComponent = Em.Component.extend
  session: Em.inject.service()

  classNames: 'yandex-business-container'

  init: ->
    src = "https://geoadv-partner.yandex.ru/static/partner-script.js"
    s = document.createElement 'script'
    s.setAttribute 'async', false
    s.setAttribute 'src', src
    document.body.appendChild s

  initWidget: (->
    Em.run.later =>
      id = @get 'session.currentOrganization.id'
      widget = window.YaPartnerWidget
      widget.init
        container: $('.yandex-business-container').get(0)
        partnerName: 'smartomato'
        partnerSiteId: id
        products: ['subscription', 'websubscription']
    , 200
  ).on('didInsertElement')